<template>
  <div class="index">
    <div class="tab">
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane v-if="status == 0" label="基本信息" name="search">
          <p>企业名称</p>
          <div class="input_box">
            <el-input v-model="companyName" placeholder="请输入企业名称"></el-input>
            <div class="search_btn" @click="searchBlur">立即查询</div>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="status == 1" label="基本信息" name="search">
          <p>企业信息表</p>
          <div class="basemsg">
            <p class="base">一、企业基本情况</p>
            <div class="msg">
              <div class="public-name">
                <p>企业名称<span style="color: red; line-height: 40px">*</span></p>
              </div>
              <div class="int">
                <input
                  type="text"
                  placeholder="请输入企业名称"
                  v-model="form.CompanName"
                  @blur="companyNameInputBlur"
                />
              </div>
            </div>
            <div class="msg msg-sec">
              <div class="public-name">
                <p>注册地区<span style="color: red; line-height: 40px">*</span></p>
              </div>
              <div class="int">
                <el-select v-model="form.AreaCode" placeholder="请选择注册地区">
                  <el-option
                    v-for="item in areaList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="msg">
              <div class="public-name">
                <p>详细地址<span style="color: red; line-height: 40px">*</span></p>
              </div>
              <div class="int">
                <input
                  type="text"
                  placeholder="请输入公司实际注册地"
                  v-model="form.Address"
                />
              </div>
            </div>
            <div class="msg msg-last">
              <div class="public-name">
                <p>注册时间<span style="color: red; line-height: 40px">*</span></p>
              </div>
              <div class="int">
                <el-date-picker
                  v-model="form.RegTime"
                  type="date"
                  placeholder="请选择注册时间"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="more-choose">
            <p class="base">二、企业所属产业类别（可多选）：</p>
            <div class="type_box">
              <!-- <el-checkbox-group v-model="form.typeList" @change="change">
                <el-checkbox-button v-for="item in typeList" :label="item" :key="item">
                  {{ item }}
                </el-checkbox-button>
              </el-checkbox-group> -->
              <div
                v-for="(item, index) in typeList"
                :key="item"
                @click="changeType(item, index)"
                class="type_item"
                ref="type_item"
                :class="form.typeList.indexOf(item) == -1 ? '' : 'chose_type'"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="power">
            <p class="base">三、科研实力：</p>
            <div class="people">
              <div class="peo-num">企业人数</div>
              <div class="style-peo">
                <div class="num">企业人员数量<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="input"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Employees.total"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">本科人员数量<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="input"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Employees.benke"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">研究生人员数量<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="input"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Employees.yanjiusheng"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">“双一流”人员数量<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="input"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Employees.shuangyiliu"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">企业科研人员数量<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="input"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Employees.keyan"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">上年度主营业务收入<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="input"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Sales"
                    placeholder="单位：万元"
                  />
                </div>
              </div>
              <div class="style-peo style-peo-last">
                <div class="num">
                  上年度是否有贷款或未来有计划贷款<span style="color: red">*</span>
                </div>
                <div class="btn int">
                  <el-radio-group v-model="form.IsLoan" style="margin: 0 40px">
                    <el-radio-button label="true" style="margin: 0; width: auto"
                      >是</el-radio-button
                    >
                    <el-radio-button label="false" style="margin: 0">否</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
          <div class="power">
            <p class="base">四、其他优势</p>
            <div class="people">
              <div class="style-peo">
                <div class="num">
                  上年设备和软件投入（万元）<span style="color: red">*</span>
                </div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.EquipmentScience"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">上年度营业收入<span style="color: red">*</span></div>
                <div class="int">
                  <input type="text" v-model="form.SalesYs" placeholder="输入整数" />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">
                  研发费用及占比主营收<span style="color: red">*</span>
                </div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.YanfaRate"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">资产负债率<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.FuzhaiRate"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">净利润率<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Jingli"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">技术合同交易额<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.JishuTraded"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">设备总投资<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Shebeizong"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">设备付款比例<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Shebemoney"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">项目总投资<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Projectmoney"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">纳税额度<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.Nashuimoney"
                    placeholder="输入整数"
                  />
                </div>
              </div>
            </div>
            <div class="people">
              <div class="peo-num">
                知识产权数量（项）
                <span>
                  <a href="http://pat.hnipo.net:8088/" target="_">知识产权查询</a>
                </span>
              </div>
              <div class="style-peo">
                <div class="num">发明<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.GeistigesEigentum.faming"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">实用<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.GeistigesEigentum.shiyong"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">外观<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.GeistigesEigentum.waiguan"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo">
                <div class="num">软件<span style="color: red">*</span></div>
                <div class="int">
                  <input
                    type="text"
                    ref="inputMoney"
                    v-for="i in 1"
                    :key="i"
                    v-model="form.GeistigesEigentum.ruanjian"
                    placeholder="输入整数"
                  />
                </div>
              </div>
              <div class="style-peo style-peo-last">
                <div class="num">税种<span style="color: red">*</span></div>
                <div class="btn int">
                  <el-radio-group v-model="form.Shuizhong">
                    <el-radio-button label="增值税"></el-radio-button>
                    <el-radio-button label="所得税"></el-radio-button>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="people" v-if="sortList.length != 0">
              <div class="peo-num">是否获得技术中心、实验室等称号</div>
              <div class="more-chose" v-for="(item, index) in sortList" :key="item.Code">
                <div class="name">
                  {{ item.FullName }} <span style="color: red">*</span>
                </div>
                <div class="lables">
                  <el-radio-group v-model="form['sort' + index]" size="small">
                    <el-radio-button
                      v-for="i in item.children"
                      :key="i.Code"
                      :label="i.Code"
                      >{{ i.FullName }}</el-radio-button
                    >
                  </el-radio-group>
                </div>
              </div>

              <div class="more-chose">
                <div class="name">质量管理体系类型 <span style="color: red">*</span></div>
                <div class="lables">
                  <el-checkbox-group v-model="form.IsotixiList" size="small">
                    <el-checkbox-button
                      label="ISO9001质量管理体系认证"
                    ></el-checkbox-button>
                    <el-checkbox-button
                      label="ISO14001环境管理体系认证"
                    ></el-checkbox-button>
                    <el-checkbox-button
                      label="ISO50001能源管理体系认证"
                    ></el-checkbox-button>
                    <el-checkbox-button
                      label="ISO45001职业健康安全管理体系认证"
                    ></el-checkbox-button>
                  </el-checkbox-group>
                </div>
              </div>
              <div class="more-chose">
                <div class="name">企业资质 <span style="color: red">*</span></div>
                <div class="lables">
                  <el-checkbox-group v-model="form.ZizhiList" size="small">
                    <el-checkbox-button v-for="op in ops" :label="op" :key="op">{{
                      op
                    }}</el-checkbox-button>
                  </el-checkbox-group>
                </div>
              </div>
              <div class="style-peo">
                <div class="num">产学研合作情况<span style="color: red">*</span></div>
                <div class="int">
                  <input type="text" v-model="form.School" placeholder="请输入学校名称" />
                </div>
              </div>
            </div>
          </div>
          <div class="marching">
            <button @click="getDetailedSearch">立即匹配</button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="匹配结果" name="result">
          <march-result
            ref="result"
            :status="status"
            :companyName="companyName"
            :form="form"
          ></march-result>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import MarchResult from "./components/MarchResult.vue";

const options = [
  "强基项目",
  "省重点项目",
  "揭榜挂帅",
  "智能制造解决方案",
  "首台套",
  "新材料",
  "规上企业",
];
import { getUserInfo, getAllIndustry, getJsonExact, getLastHistory } from "@/api/index";
export default {
  data() {
    return {
      companyName: "",
      status: 0,
      checkboxGroup1: [""],
      typeList: [],
      ops: options,
      checkboxGroup2: [""],
      areaList: [
        {
          value: "RegisterArea_",
          label: "国家部委",
        },
        {
          value: "RegisterArea_HZDQ_Hunan",
          label: "湖南省",
        },
        {
          value: "RegisterArea_HZDQ_Hunan_ZhuZhouShi",
          label: "株洲市",
        },
        {
          value: "RegisterArea_HZDQ_Hunan_ZhuZhouShi_HTQ",
          label: "荷塘区",
        },
      ],
      sortList: [],
      value: "",
      activeName: "search",
      form: {
        typeList: [],
        Employees: {},
        GeistigesEigentum: {},
        ZizhiList: [],
        IsotixiList: [],
        sort0: "",
        sort1: "",
        sort2: "",
        sort3: "",
        sort4: "",
      },
    };
  },
  components: {
    MarchResult,
  },
  mounted() {
    this.status = this.$route.query.status;
    if (this.status == 1) {
      this.checkInfo();
      this.getHistory();
    }
    this.getTypeList();
    this.getSortList();
  },
  watch: {
    $route(newVal, oldVal) {
      // console.log(newVal.query.status);
      if (newVal.query.status != oldVal.query.status) {
        this.status = newVal.query.status;
      }
    },
  },
  methods: {
    getHistory(key = "") {
      getLastHistory({
        token: localStorage.getItem("token"),
        CompanyName: key,
      }).then((res) => {
        // console.log(res.data.data);
        if (res.data.data) {
          this.form = res.data.data;
          this.form.typeList = [];
          console.log(this.form);
          this.form.ZizhiList = this.form.Zizhi ? this.form.Zizhi.split(",") : [];
          if (this.form.Industries) {
            this.form.Industries.split(",").forEach((item) => {
              this.form.typeList.push(item);
            });
          } else {
            this.form.typeList = [];
          }
          this.form.IsotixiList = this.form.Isotixi ? this.form.Isotixi.split(",") : [];
          if (this.form.IsAcquireTechnique) {
            this.form.sort0 = this.form.IsAcquireTechnique.split(",")[0];
            this.form.sort1 = this.form.IsAcquireTechnique.split(",")[1];
            this.form.sort2 = this.form.IsAcquireTechnique.split(",")[2];
            this.form.sort3 = this.form.IsAcquireTechnique.split(",")[3];
            this.form.sort4 = this.form.IsAcquireTechnique.split(",")[4];
          }
          if (key) {
            this.$message.success("已获取公司信息");
          }
        } else {
          this.form = {
            typeList: [],
            Employees: {},
            GeistigesEigentum: {},
            ZizhiList: [],
            IsotixiList: [],
            sort0: "",
            sort1: "",
            sort2: "",
            sort3: "",
            sort4: "",
          };
          this.form.CompanName = key;
        }
        // console.log(this.form);
      });
    },
    async companyNameInputBlur() {
      await this.getHistory(this.form.CompanName);
    },
    checkInfo() {
      getUserInfo({
        token: localStorage.getItem("token"),
      }).then((res) => {
        let vip = res.data.data.vip;
        if (vip != 1) {
          if (vip == 0) {
            this.$message.error("请先成为会员");
          }
          if (vip == 2) {
            this.$message.error("会员已过期");
          }
          window.history.back();
        }
      });
    },
    getTypeList() {
      getAllIndustry({}).then((res) => {
        res.data.forEach((item) => {
          this.typeList.push(item.fullName);
        });
      });
    },
    getSortList() {
      getJsonExact({}).then((res) => {
        // console.log(res);
        this.sortList = res.data.data.filter((item) => {
          return item.ParentCode == "Cxzt";
        });
        this.sortList.forEach((item) => {
          item.children = res.data.data.filter((i) => {
            return i.ParentCode == item.Code;
          });
        });
        // console.log(this.sortList);
      });
    },
    searchBlur() {
      if (!this.companyName) {
        this.$message.error("公司名称不能为空");
        return;
      }
      this.activeName = "result";
      this.$refs.result.getResult();
    },
    getDetailedSearch() {
      if (!this.form.CompanName) {
        this.$message.error("公司名称不能为空");
        return;
      }
      if (!this.form.AreaCode) {
        this.$message.error("请先选择公司注册地区");
        return;
      }
      if (!this.form.Address) {
        this.$message.error("公司详情地址不能为空");
        return;
      }
      if (!this.form.RegTime) {
        this.$message.error("请先选择公司注册时间");
        return;
      }
      if (this.form.typeList.length == 0) {
        this.$message.error("请先选择企业所属产业类别");
        return;
      }
      let inputTag = this.$refs.input.every((item) => {
        return item.value.indexOf(".") == -1 && item.value >= 0 && item.value != "";
      });
      if (!inputTag) {
        this.$message.error("数据必须为包括0以上的整数");
        return;
      }
      if (!this.form.IsLoan) {
        this.$message.error("请选择企业贷款计划");
        return;
      }
      let inputMoneyTag = this.$refs.inputMoney.every((item) => {
        return item.value >= 0 && item.value != "";
      });
      // console.log(inputTag, inputMoneyTag);
      if (!inputMoneyTag) {
        this.$message.error("数据继续必须大于等于0");
        return;
      }
      if (!this.form.Shuizhong) {
        this.$message.error("请选择税种");
        return;
      }
      if (!this.form.sort0) {
        this.$message.error("请选择是否获得技术中心、实验室等称号");
        return;
      }
      if (!this.form.sort1) {
        this.$message.error("请选择是否获得技术中心、实验室等称号");
        return;
      }
      if (!this.form.sort2) {
        this.$message.error("请选择是否获得技术中心、实验室等称号");
        return;
      }
      if (!this.form.sort3) {
        this.$message.error("请选择是否获得技术中心、实验室等称号");
        return;
      }
      if (!this.form.sort4) {
        this.$message.error("请选择是否获得技术中心、实验室等称号");
        return;
      }
      if (this.form.IsotixiList.length == 0) {
        this.$message.error("请选择质量管理体系类型");
        return;
      }
      if (this.form.ZizhiList.length == 0) {
        this.$message.error("请选择企业资质");
        return;
      }
      if (!this.form.School) {
        this.$message.error("请输入学校名称");
        return;
      }
      this.form.Zizhi = this.form.ZizhiList.join(",");
      this.form.Industries = this.form.typeList.join(",");
      this.form.Isotixi = this.form.IsotixiList.join(",");
      this.form.IsAcquireTechnique = [
        this.form.sort0,
        this.form.sort1,
        this.form.sort2,
        this.form.sort3,
        this.form.sort4,
      ].join(",");
      this.activeName = "result";
      this.$refs.result.getResult();
    },
    changeType(item, index) {
      // console.log(
      //   this.$refs.type_item[index].classList,
      //   this.form.typeList.indexOf(item)
      // );
      if (this.form.typeList.indexOf(item) == -1) {
        this.form.typeList.push(item);
        this.$refs.type_item[index].classList.add("chose_type");
      } else {
        this.form.typeList = this.form.typeList.filter((i) => {
          return item != i;
        });
        this.$refs.type_item[index].classList.remove("chose_type");
      }
      // console.log(this.form.typeList);
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  overflow: auto;
  .tab {
    .el-tabs {
      .el-tab-pane {
        p {
          height: 40px;
          line-height: 40px;
          font-size: 25px;
          font-weight: bold;
        }
        .basemsg {
          .base {
            text-align: left;
            height: 40px;
            line-height: 40px;
            font-size: 20px;
            font-weight: normal;
            display: flex;
            justify-content: space-between;
            button {
              width: 60px;
              height: 30px;
              margin-top: 5px;
              background-color: #409eff;
              border: none;
              color: white;
            }
          }
          .msg {
            border: 1px solid rgb(218, 214, 214);
            height: 40px;
            display: flex;
            text-align: left;
            .public-name {
              width: 50%;
              border-right: 1px solid rgb(218, 214, 214);
              p {
                font-size: 16px;
                line-height: 40px;
                font-weight: normal;
                padding-left: 20px;
              }
            }
            .int {
              width: 50%;
              input {
                outline: none;
                border: none;
                padding-left: 20px;
                line-height: 35px;
                height: 35px;
                width: 96%;
                margin-top: 2px;
              }
              .el-select {
                line-height: 35px;
                height: 35px;
                width: 96%;
                border: none;
                text-align: left;
                padding: 0;
                ::v-deep .el-select__caret {
                  display: none;
                }
                ::v-deep .el-input__inner {
                  line-height: 35px;
                  height: 35px;
                  width: 96%;
                  border: none;
                  text-align: left;
                  padding: 0;
                  outline: none;
                  color: black;
                  padding-left: 20px;
                }
              }
              .el-input {
                line-height: 35px;
                height: 35px;
                width: 96%;
                border: none;
                text-align: left;
                padding: 0;
                padding-left: 20px;
                ::v-deep .el-input__icon {
                  display: none;
                }
                ::v-deep .el-input__inner {
                  line-height: 35px;
                  height: 35px;
                  width: 96%;
                  border: none;
                  text-align: left;
                  padding: 0;
                  outline: none;
                  color: black;
                }
              }
            }
          }
          .msg-sec {
            border-top: 0;
            border-bottom: 0;
          }
          .msg-last {
            border-top: 0;
          }
        }
        .more-choose {
          margin-top: 20px;
          .base {
            text-align: left;
            height: 40px;
            line-height: 40px;
            font-size: 20px;
            font-weight: normal;
          }
          .check-box {
            .el-checkbox-group {
              display: flex;
              flex-wrap: wrap;
              .el-checkbox-button {
                margin-right: 20px;
                margin-top: 20px;
                // border-left: 1px solid rgb(208, 203, 203);
                border-radius: 5px;
              }
            }
          }
        }
        .power {
          margin-top: 20px;
          .base {
            text-align: left;
            height: 40px;
            line-height: 40px;
            font-size: 20px;
            font-weight: normal;
          }
          .people {
            line-height: 40px;
            text-align: left;
            border: 1px solid rgb(214, 212, 212);
            border-bottom: none;
            margin-top: 20px;
            .peo-num {
              border-bottom: 1px solid rgb(214, 212, 212);
              padding-left: 20px;
              display: flex;
              justify-content: space-between;
              span {
                color: #409eff;
                margin-right: 30px;
              }
            }
            .style-peo {
              height: 40px;
              line-height: 40px;
              display: flex;
              text-align: left;
              border-bottom: 1px solid rgb(214, 212, 212);
              .num {
                padding-left: 20px;
                width: 50%;
                border-right: 1px solid rgb(214, 212, 212);
              }
              .int {
                width: 50%;
                input {
                  width: 90%;
                  height: 30px;
                  border: none;
                  outline: none;
                  padding-left: 20px;
                }
              }
            }
            .style-peo-last {
              height: 60px;
              line-height: 60px;
              .btn {
                .el-radio-button {
                  margin: 0 60px;
                  width: 80px;
                }
              }
            }
            .more-chose {
              min-height: 60px;
              line-height: 60px;
              display: flex;
              text-align: left;
              border-bottom: 1px solid rgb(214, 212, 212);
              .name {
                width: 200px;
                border-right: 1px solid rgb(214, 212, 212);
                padding-left: 20px;
                white-space: nowrap;
              }
              .lables {
                flex: 1;
                padding-left: 20px;
                .el-radio-group {
                  display: flex;
                  justify-content: space-around;
                  flex-wrap: wrap;
                  margin-bottom: 15px;
                  .el-radio-button {
                    margin-top: 15px;
                  }
                }
                .el-checkbox-group {
                  display: flex;
                  justify-content: space-around;
                  flex-wrap: wrap;
                  margin-bottom: 15px;
                  .el-checkbox-button {
                    margin-top: 15px;
                    line-height: 1;
                  }
                }
              }
            }
          }
        }
        .marching {
          height: 70px;
          line-height: 70px;
          button {
            width: 70px;
            height: 40px;
            background-color: #409eff;
            color: white;
            border: none;
          }
        }
      }
    }
  }
}
.index {
  .input_box {
    margin-top: 20px;
    width: 400px;
    .search_btn {
      display: inline-block;
      margin-top: 20px;
      padding: 5px 10px;
      background: #409eff;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}
/deep/.el-checkbox-button__inner {
  border-left: 1px solid #dcdfe6;
}
/deep/.el-radio-button__inner {
  border-left: 1px solid #dcdfe6;
}
.type_box {
  display: flex;
  flex-wrap: wrap;
  .type_item {
    padding: 8px 16px;
    margin: 10px 10px 10px 0;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      border: 1px solid #409eff;
    }
  }
  .chose_type {
    border: 1px solid #409eff;
    background: #409eff;
    color: #fff;
  }
}
</style>
